import { forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, ButtonCross } from 'components/buttons';
import { ModalDefaultProps } from 'components/Modal';
import { ModalsContext, ModalType } from 'contexts/modal';
import { useTheme } from 'hooks/theme';

import { ScMysticCarnival } from './styled';

import coin from 'assets/images/coins/coin4.png';
import flyingFrame from 'assets/images/EasterWonderland/flyingFrame.png';
import { ImageComponent } from 'components/Image';

export const EasterWonderland = forwardRef<HTMLDivElement, ModalDefaultProps>(
  ({ onClose }, ref) => {
    const {
      t,
      i18n: { language },
    } = useTranslation('easterWonderland');

    const {
      frequencyIcon: FrequencyIcon,
      wagerIcon: WagerIcon,
      minDepIcon: MinDepIcon,
    } = useTheme();

    const { handleModal } = useContext(ModalsContext);

    const handleDeposit = () => {
      handleModal(ModalType.Deposit)();
    };

    return (
      <ScMysticCarnival ref={ref}>
        <ButtonCross top={8} right={8} onClick={onClose} />

        <img src={coin} alt="coin" className="coin" />
        <ImageComponent
          width={146}
          height={146}
          src={flyingFrame}
          alt=""
          className="flying-frame"
        />

        <div className={`content ${language}`}>
          <h3>{t('title')}</h3>

          <div className="details">
            <div className="details__offer">{t('offer')}</div>
            <h2>{t('easterWonderland:available')}</h2>
            <div className="details__terms">
              <div className="item">
                <div className="icon">
                  <FrequencyIcon />
                </div>
                <div className="value">{t('frequency')}</div>
              </div>
              <div className="item">
                <div className="icon">
                  <WagerIcon />
                </div>
                <div className="value">{t('wager')}</div>
              </div>
              <div className="item">
                <div className="icon">
                  <MinDepIcon />
                </div>
                <div className="value">{t('minDep')}</div>
              </div>
            </div>

            <Button green wide onClick={handleDeposit}>
              {t('glossary:getBonus')}
            </Button>
          </div>
        </div>
      </ScMysticCarnival>
    );
  }
);
